import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcMaximizeFill(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "25",
    fill: "none",
    viewBox: "0 0 24 25",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14 5.881a1.1 1.1 0 0 1 0-2.2h6a1.1 1.1 0 0 1 1.1 1.1v6a1.1 1.1 0 0 1-2.2 0V7.437l-4.122 4.122a1.1 1.1 0 1 1-1.556-1.555l4.122-4.123zm-11.1 8.9a1.1 1.1 0 0 1 2.2 0v3.345l4.122-4.123a1.1 1.1 0 1 1 1.556 1.556l-4.122 4.122H10a1.1 1.1 0 0 1 0 2.2H4a1.1 1.1 0 0 1-1.1-1.1z",
    clipRule: "evenodd"
  }));
}
var IcMaximizeFill = createNolIcon(/*#__PURE__*/forwardRef(SvgIcMaximizeFill));

export { IcMaximizeFill as I };
